import classes from '../Pages.module.css';
import { Row, Col, Tabs, Skeleton, message } from 'antd';
import axios from 'axios';
import DataContext from '../../../Context/dataContext';
import { useState, useEffect, useContext } from 'react';
import BasicLeaveDetails from './BasicLeaveDetails';
import LeaveNormDetails from './LeaveNormDetails';
import { useNavigate } from 'react-router';
import SyncLoader from "react-spinners/SyncLoader";

const { TabPane } = Tabs;

const LeaveNormsCreate = (props) => {

  const employeeData = useContext(DataContext)
  const history = useNavigate();

  const [ad, setAD] = useState(null)
  const [loading, setLoading] = useState(false)
  const [editMode, setEditMode] = useState(true)
  const [allData, setAllData] = useState(
    {
      "header": {
        "metaData": [
          {
            "name": "norms_hdr_code"
          },
          {
            "name": "emp_code"
          },
          {
            "name": "unit_code"
          },
          {
            "name": "department_code"
          },
          {
            "name": "designation_code"
          },
          {
            "name": "emp_type"
          },
          {
            "name": "age"
          },
          {
            "name": "gender"
          },
          {
            "name": "distancefrom"
          },
          {
            "name": "distanceto"
          },
          {
            "name": "from_date"
          },
          {
            "name": "to_date"
          },
          {
            "name": "associated_comp"
          },
          {
            "name": "associated_comp_to"
          }
        ],
        "rows": [
          {
            "emp_code": null,
            "unit_code": null,
            "department_code": null,
            "designation_code": null,
            "emp_type": null,
            "age": null,
            "gender": null,
            "distancefrom": null,
            "distanceto": null,
            "from_date": null,
            "to_date": null,
            "associated_comp": null,
            "associated_comp_to": null
          }
        ]
      },
      "details": {
        "metaData": [
          {
            "name": "uniq_id"
          },
          {
            "name": "leave_type"
          },
          {
            "name": "leaves_no"
          },
          {
            "name": "leave_pay"
          },
          {
            "name": "month_increment"
          }
        ],
        "rows": []
      }
    }
  );


  useEffect(() => {

    setAD(null)
    axios
      .get(employeeData.URL + '/api/v1/norms/leave-norms/additional-data', {
        withCredentials: true
      })
      .then((response) => {

        console.log(response);
        setAD(ad => {
          let newad = response.data.data
          return ({
            ...newad,
            GENDER: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "M", VALUE: "Male" }, { KEY: "F", VALUE: "Female" }]
            },
            YESNO: {
              fields: [{ name: "KEY" }, { name: "VALUE" }],
              rows: [{ KEY: "Y", VALUE: "Yes" }, { KEY: "N", VALUE: "No" }]
            },
          });
        })
      })
      .catch((error) => {
        console.log(error);
      })

  }, [])

  // const handleSave = (event) => {

  //   var formv = true

  //  if((allData.header.from_date==null)&&(allData.header.to_date==null)){
  //   message.error({
  //     content: "Please Fill the Mandatory Fields!!!",
  //     className: "custom-class",
  //     style: {
  //       marginTop: "1vh",
  //     },
  //  })};

  //  console.log(allData.header.rows[0].from_date," This is from_date");
  //  console.log(allData.header.rows[0].to_date," This is to_date");

  //  if(allData.header.rows[0].from_date>allData.header.rows[0].to_date){
  //   message.error({
  //     content: "To date can't be less then from date!!!",
  //     className: "custom-class",
  //     style: {
  //       marginTop: "1vh",
  //     },
  //  })};
  //  let count = 0;
  //   allData.details.rows.forEach(data => {

  //       if(!data){

  //           formv = formv&&false
  //           if(count === 0){
  //               message.error({
  //                   content: 'Empty Fields In LEAVE NORM DETAILS Tab!!!',
  //                   className: 'custom-class',
  //                   style: {
  //                       marginTop: '1vh',
  //                   },
  //               });
  //           }

  //           count = count + 1;
  //       }
  //   })

  //   if(formv){

  //     console.log("Submitting");

  //     const postData = {
  //       "header": allData.header.rows,
  //       "details": allData.details.rows,
  //     }

  //     console.log(JSON.stringify(postData, undefined, 2));
  //     setLoading(true)
  //     axios
  //       .post(employeeData.URL + '/api/v1/norms/leave-norms', postData,  {
  //           withCredentials: true,
  //           credentials: 'include',
  //       })
  //       .then((response) => {
  //           message.success({
  //               content: 'Leave Norm Created Successfully!!!',
  //               className: 'custom-class',
  //               style: {
  //                   marginTop: '2vh',
  //               },
  //           });
  //           setLoading(false)
  //           history('/payroll/norms/leave-norms')
  //       })
  //       .catch((err) => {
  //           message.error({
  //               content: 'An Error Occurred!!!!',
  //               className: 'custom-class',
  //               style: {
  //                   marginTop: '2vh',
  //               },
  //           });
  //           setLoading(false)
  //       });
  //   }

  // }
  const handleSave = (event) => {
    let formv = true;
    const header = allData.header.rows[0];

    // Validate header dates
    if (!header?.from_date || !header?.to_date) {
      message.error({
        content: "Please Fill the Mandatory Fields!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      formv = false;
    }
    else if (header.from_date > header.to_date) {
      message.error({
        content: "To date can't be less than from date!!!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      formv = false;
    }

    // Validate details section
    if (!allData.details?.rows || allData.details.rows.length === 0) {
      message.error({
        content: "LEAVE NORM DETAILS cannot be empty!",
        className: "custom-class",
        style: { marginTop: "1vh" },
      });
      formv = false;
    }
    else {
      let hasEmptyDetails = false;
      allData.details.rows.forEach((data) => {
        if (!data || Object.keys(data).length === 0) {
          hasEmptyDetails = true;
        }
      });

      if (hasEmptyDetails) {
        message.error({
          content: "Empty Fields In LEAVE NORM DETAILS Tab!!!",
          className: "custom-class",
          style: { marginTop: "1vh" },
        });
        formv = false;
      }
    }

    if (!formv) return;

    // Proceed with submission
    const postData = {
      header: allData.header.rows,
      details: allData.details.rows,
    };

    setLoading(true);
    axios.post(employeeData.URL + "/api/v1/norms/leave-norms", postData, {
      withCredentials: true,
      credentials: "include",
    })
      .then((response) => {
        message.success({
          content: "Leave Norm Created Successfully!!!",
          className: "custom-class",
          style: { marginTop: "2vh" },
        });
        history("/payroll/norms/leave-norms");
      })
      .catch((err) => {
        message.error({
          content: "An Error Occurred!!!!",
          className: "custom-class",
          style: { marginTop: "2vh" },
        });
      })
      .finally(() => setLoading(false));
  };





  const handleCancel = (event) => {

    setLoading(false)
    history('/payroll/norms/leave-norms')
  }
  return (
    ad
      ?
      <Row className={classes['RowP']}>
        <Col lg={editMode ? 13 : 19}
          md={editMode ? 13 : 19}
          className={classes['Col']} >
        </Col>
        {editMode ?
          <>
            <Col md={4} >
              {loading ?
                <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                :
                <button
                  style={{
                    padding: "7px 30px 14px 24px",
                    borderRadius: "50px",
                    background: "transparent",
                    width: "100%",
                    border: "none",
                    outline: "none",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "1.5",
                    color: "#071e54",
                    WebkitAppearance: "none",

                    boxShadow:
                      "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                    height: "40px",

                    // Ensure the button takes full width
                  }}
                  onClick={(event) => handleSave(event)}
                  className={classes["ProfileButtonn"]}
                  id="save"
                  onMouseOver={(event) => {
                    event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                  }}
                  onMouseOut={(event) => {
                    event.target.style.boxShadow =
                      "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                  }}
                >
                  Save
                </button>
              }

            </Col>
            <Col md={4} >
              {loading
                ?
                <SyncLoader color={"rgba(255,163,77,0.8)"} size={10} />
                :
                <button
                  style={{
                    padding: "7px 30px 14px 24px",
                    borderRadius: "50px",
                    background: "transparent",
                    width: "100%",
                    border: "none",
                    outline: "none",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "1.5",
                    color: "#071e54",
                    WebkitAppearance: "none",

                    boxShadow:
                      "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff", // Original box shadow
                    height: "40px",

                    // Ensure the button takes full width
                  }}
                  onClick={(event) => handleCancel(event)}
                  onMouseOver={(event) => {
                    event.target.style.boxShadow = "0px 5px 15px 0px #264a9f"; // Apply spread color on hover with 0 spread at the top
                  }}
                  onMouseOut={(event) => {
                    event.target.style.boxShadow =
                      "-3px -3px 6px #fff, 3px 3px 6px #bfc3cf, 3px 3px 6px #bfc3cf, -3px -3px 6px #fff"; // Restore original shadow on mouse out
                  }}
                  className={classes["ProfileButtonn"]}
                >
                  Cancel
                </button>
              }
            </Col>
          </>
          :
          <Col md={4} >
            <button onClick={() => setEditMode(true)} className={classes['ProfileButton']}>Edit Details</button>
          </Col>
        }

        <Col lg={24} md={24}>
          <p></p>
          <div className={classes['EditView']}>


            <BasicLeaveDetails create={true} ad={ad} setData={setAllData} data={allData.header.rows[0]} editMode={editMode} />
            <Tabs
              centered
              tabPosition="top"
              style={{ display: "flex", justifyContent: "center" }}
            >
              <TabPane tab={<span>Norm Detail</span>} key="0" type="line">
                <LeaveNormDetails ad={ad} editMode={editMode} setData={setAllData} data={allData.details.rows} />
              </TabPane>
            </Tabs>

          </div>
        </Col>
      </Row>
      :
      <>
        <Skeleton active={true} />
        <Skeleton active={true} />
        <Skeleton active={true} />
      </>
  );
};


export default LeaveNormsCreate;